import { Wrap, StyledTitle, StyledList, StyledItem } from './styles';

import type { FC } from 'react';

type OrderedListItem = {
  text?: string | null;
};

export type OrderedListProps = {
  title?: string | null;
  items?: OrderedListItem[] | null;
};

export const OrderedList: FC<OrderedListProps> = ({ title, items }) => {
  if (!title && !items?.length) {
    return null;
  }

  return (
    <Wrap>
      {title ? <StyledTitle>{title}</StyledTitle> : null}
      {items?.length ? (
        <StyledList>
          {items.map((item, index) => (
            <StyledItem key={`${index}-${item}`}>{item.text}</StyledItem>
          ))}
        </StyledList>
      ) : null}
    </Wrap>
  );
};
